import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5dc88e68&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=5dc88e68&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=5dc88e68&prod&scoped=true&lang=css"
import style2 from "./App.vue?vue&type=style&index=2&id=5dc88e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc88e68",
  null
  
)

export default component.exports